import { BCMSDate, BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useModel, useStateManager } from "@bcm-dev/bcms-vite";
import { PageContainer, PageContentView } from 'components/shared';
import Classes, { Account, OneTimeWireTransfer, OutgoingFedWire, IncomingFedWire, WireHistory } from "model";
import React from 'react';
import OutgoingFedWiresWidget from "./components/OutgoingFedWiresWidget";
import IncomingFedWiresWidget from "./components/IncomingFedWiresWidget";
import OutgoingFedWiresSearchForm from "./components/OutgoingFedWiresWidget/classes/SearchForm";
import IncomingFedWiresSearchForm from "./components/IncomingFedWiresWidget/classes/SearchForm";
import "./styles.css";
import "./mobile.css";

/**
 * @function FedWiresPage
 * @return {React.Component}
 * @exported true
 * @description - The page for fed wires.
 */

export default function FedWiresPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  // Branding options needed for captures
  const branding = useModel().branding.options;
  window.BRANDING = { 
      "wires_abi22" : branding.wires_abi22
  };

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    // Modify the ui in this page from a widget.
    modifyPageUIFromWidget: (widgetID, dataProp) => val => {
      BCMSStateManagerCRUD.init(state)
      .update([ "ui", widgetID, dataProp ], val)
      .submit(setState);
    }
  });

  return(
    <PageContainer className="fed-wires-page" state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultData = () => ({
  outgoingFedWiresWidgetData: {
    accounts: Account.initAllAsset(),
    outgoingFedWires: OutgoingFedWire.initAll(),
    search: OutgoingFedWiresSearchForm.init()
  },
  incomingFedWiresWidgetData: {
    accounts: Account.initAllAsset(),
    outgoingFedWires: IncomingFedWire.initAll(),
    search: IncomingFedWiresSearchForm.init()
  }
});

// no ui changes for now
export const getDefaultUI = () => ({
  outgoingFedWiresWidgetUI: {
    showSearchOptions: { isActive: false },
  },
  incomingWiresWidgetUI: {
    showSearchOptions: { isActive: false },
  },
});

function PageContent(props) {
  const { data, ui, modifyPageUIFromWidget } = useStateManager();
  const action = { modifyPageUIFromWidget: modifyPageUIFromWidget };

  return (
  <PageContentView>
    <div className="flex-container flex-vertical flex-width">
      <OutgoingFedWiresWidget data={ data.outgoingFedWiresWidgetData } ui={ ui.outgoingFedWiresWidgetUI } action={ action } />
      <IncomingFedWiresWidget data={ data.incomingFedWiresWidgetData } ui={ ui.incomingWiresWidgetUI } action={ action } />
    </div>
  </PageContentView>
  );
}